<template>
  <div />
</template>
<script>
import utils from '@/utils'

export default {
  name: 'JsonLdBreadcrumb',
  props: {
    allRegions: { type: Array, default: () => [], required: true },
    region: { type: Object, default: () => {}, required: true },
    branch: { type: Object, default: () => {}, required: true },
    product: { type: Object, default: () => {} },
  },
  jsonld() {
    const homeItem = {
      '@type': 'ListItem',
      position: 1,
      item: {
        '@id': this.$config.public.BASE_URL + '/',
        name: this.$t('funnow_title'),
        image: 'https://cdn.myfunnow.com/web/og_images/web_cover.png',
      },
    }

    const regionItem = {
      '@type': 'ListItem',
      position: 2,
      item: {
        '@id': this.$config.public.BASE_URL + `/regions/${this.region.id}`,
        name: this.region.name,
      },
    }
    const currRegion = this.allRegions.find(region => {
      return region.region_id === this.region.id
    })
    if (currRegion) {
      regionItem.item.image = `${utils.CDN}${utils.imagePath(currRegion.region_image)}`
    }

    const branchItem = {
      '@type': 'ListItem',
      position: 3,
      item: {
        '@id': this.$config.public.BASE_URL + `/branches/${this.branch.bid}`,
        name: this.branch.name,
        image: `${utils.CDN}${utils.imagePath(this.branch.cover_image)}`,
      },
    }

    const jsonld = {
      '@context': 'http://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [homeItem, regionItem, branchItem],
    }

    if (!utils.isEmpty(this.product)) {
      const productItem = {
        '@type': 'ListItem',
        position: 4,
        item: {
          '@id': this.$config.public.BASE_URL + `/products/${this.product.pid}`,
          name: this.product.product_name,
          image: `${utils.CDN}${utils.imagePath(this.product.cover_image)}`,
        },
      }
      jsonld.itemListElement.push(productItem)
    }

    return jsonld
  },
}
</script>
